// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9d20c140","229":"09107217"}[chunkId] + ".chunk.js";
};